export default __webpack_public_path__ + "static/proxima-nova-400-i-31e067c9863d0bc3a51751449a5c8dcc.woff";